// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.save-btn[data-v-06ce337a] {\n    height: 40px;\n    box-sizing: border-box;\n}\n.border-box--gray[data-v-06ce337a] {\n    border-radius: 4px;\n    border: solid 1px var(--color-bluish-grey);\n}\n", ""]);
// Exports
module.exports = exports;
